module.exports = __webpack_public_path__ + "static/media/e-Boks Plus Sandbox TCs (v.2).0784353b.pdf";